import { createAction, props } from '@ngrx/store'
import { HttpErrorResponse } from '@angular/common/http'
import { EventTicketPurchaseEntity } from './event-ticket-purchases.models'
import { Update } from '@ngrx/entity'

export const startEventTicketPurchase = createAction(
  '[EventTicketPurchases/Page] Start Event Ticket Purchase',
  props<{ amount: number }>(),
)

export const updateAmount = createAction('[EventTicketPurchases/Page] Update Amount', props<{ amount: number }>())

export const openPaymentDialog = createAction('[EventTicketPurchases/Page] Open Payment Dialog')

export const placeEventTicketPurchase = createAction('[EventTicketPurchases/API] Place Event Ticket Purchase')

export const placeEventTicketPurchaseSuccess = createAction(
  '[EventTicketPurchases/API] Place Event Ticket Purchase Success',
  props<{ eventTicketPurchase: EventTicketPurchaseEntity }>(),
)

export const placeEventTicketPurchaseFailure = createAction(
  '[EventTicketPurchases/API] Place Event Ticket Purchase Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const finaliseEventTicketPurchase = createAction('[EventTicketPurchases/API] Finalise Event Ticket Purchase')

export const finaliseEventTicketPurchaseSuccess = createAction(
  '[EventTicketPurchases/API] Finalise Event Ticket Purchase Success',
)

export const syncEventTicketPurchase = createAction(
  '[EventTicketPurchases/API] Sync Event Ticket Purchase',
  props<{ uuid: string }>(),
)

export const syncEventTicketPurchaseSuccess = createAction(
  '[EventTicketPurchases/API] Sync Event Ticket Purchase Success',
  props<{ update: Update<EventTicketPurchaseEntity> }>(),
)

export const syncEventTicketPurchaseFailure = createAction(
  '[EventTicketPurchases/API] Sync Event Ticket Purchase Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearAmount = createAction('[EventTicketPurchases/Page] Clear Amount')

export const clearPayment = createAction('[EventTicketPurchases/Page] Clear Payment')

export const clearSelectedEventTicketPurchase = createAction(
  '[EventTicketPurchases/Page] Clear Selected Event Ticket Purchase',
)
